/* eslint-disable @nx/enforce-module-boundaries */
import { Card, Stack, HStack, Text, Spinner, VStack, Image } from '@mybridge/ui';
import { forwardRef, useContext, useEffect } from 'react';
import { SearchCompanyCard } from 'v4/components/company/search-listing-card';
import { SearchContext } from '../../context';
import { SearchCardSkeleton } from '../../search-card-skeleton';
import InfiniteScroll from 'react-infinite-scroll-component';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const SearchCompanyPagesListing = forwardRef(
  ({ count = 0, listing, isMainList, ...props }, ref) => {
    const {
      companyPagesSearchListing,
      refetchCompanyPagesSearch,
      companyPagesSearchIsFetching,
      search,
      activeTab,
      companyPagesFetchNextPage,
      companyPagesHasNextPage,
      companyPagesTotalCount,
    } = useContext(SearchContext);
    const { t } = useTranslator();

    useEffect(() => {
      if (!listing && activeTab === 'pages') {
        refetchCompanyPagesSearch?.();
      }
    }, [search, listing, activeTab]);

    const list = listing ?? companyPagesSearchListing;

    return (
      <Stack w="100%" mt={2} spacing={4}>
        {list?.length <= 0 && companyPagesSearchIsFetching ? (
          <SearchCardSkeleton />
        ) : (
          ''
        )}
        {isMainList ? (
          <>
            {list?.map?.((li, liIndex) => (
              <Card boxShadow="0 1px 3px 0 rgba(0, 0, 0, 0.1),0 1px 2px 0 rgba(0, 0, 0, 0.06)" borderRadius="20px" minH={"290px"} mx={isMobile?"auto":""} w={isMobile?"96%":"398px"} border="0.5px solid #D4D4D4" flex={1} p={4} key={liIndex} mb={4}>
                <SearchCompanyCard company={li} />
              </Card>
            ))}
          </>
        ) : (
          <>{companyPagesTotalCount > 0 ? <InfiniteScroll
            dataLength={list?.length}
            next={companyPagesFetchNextPage}
            hasMore={companyPagesHasNextPage}
            loader={
              <HStack p={4} justifyContent="center" w="100%">
                <Spinner />
              </HStack>
            }
            // endMessage={
            //   <Text style={{ textAlign: 'center' }}>
            //     Yay! You have seen it all
            //   </Text>
            // }
          >
            {list?.map?.((li, liIndex) => (
              <Card boxShadow="0 1px 3px 0 rgba(0, 0, 0, 0.1),0 1px 2px 0 rgba(0, 0, 0, 0.06)" borderRadius="20px" minH={"290px"} m={isMobile?"auto":""} w={isMobile?"96%":"398px"} border="0.5px solid #D4D4D4" flex={1} p={4} key={liIndex} mb={4}>
                <SearchCompanyCard company={li} />

              </Card>
            ))}
          </InfiniteScroll> : <VStack
                justifyContent="center"
                alignItems="center"
                h="calc(80vh - 64px)"
              >
                <Image
                    src="/images/defaultSearchImage.svg"
                    alt="default Image"
                    width={["80%", "400px"]}
                  />
                <Text fontSize="18px" color="#AFAFAF" fontWeight="500">{t('searchPage.noResultsFound') || "No results found"}</Text>
                <Text fontSize="14px" color="#AFAFAF" fontWeight="500">{t('searchPage.tryRephrasing') || "Try shortening or rephrasing your search."}</Text>
              </VStack>}</>
          
        )}
      </Stack>

    );
  }
);
